import EnumSet from 'Services/enumSet'

export interface IPlanBenefitTypes extends EnumSet {
  id: string
  name: string
  price: string
  priority: string
  discount: string
  bonus: string
  category: string
  city: string
  position: string
  support: string
}

const PlanBenefitTypes = new EnumSet({
  id: { value: 'id', description: 'Identificador' },
  name: { value: 'name', description: 'Nome do plano' },
  price: { value: 'price', description: 'Preço mensal' },
  priority: { value: 'priority', description: 'Prioridade nos pedidos' },
  discount: { value: 'discount', description: 'Descontos na compra de oportunidades' },
  bonus: { value: 'bonus', description: 'Bônus mensal para comprar de oportunidades' },
  category: { value: 'category', description: 'Limite de especialidades anunciadas' },
  city: { value: 'city', description: 'Limite de cidades' },
  position: { value: 'position', description: 'Posição na lista de fornecedores' },
  support: { value: 'support', description: 'Suporte avançado' },
}) as IPlanBenefitTypes

export default PlanBenefitTypes